// Feedbacks will be sent to Plex's feedback project
// https://customerfeedback.atlassian.net/jira/servicedesk/projects/SANDSF/queues/custom/108
export const ENTRYPOINT_ID: string = "9b88e53b-d04d-4f1c-ae85-6d7f59d1ca7a";
export const FEEDBACK_CONTEXT_FIELD_ID = "customfield_10047";
export const SOURCE = "rovo-extension";
